const ICONS = [
  { name: "account", category: "standard" },
  { name: "account_info", category: "standard" },
  { name: "action_list_component", category: "standard" },
  { name: "actions_and_buttons", category: "standard" },
  { name: "activation_target", category: "standard" },
  { name: "activations", category: "standard" },
  { name: "activity", category: "utility" },
  { name: "ad_set", category: "utility" },
  { name: "add", category: "utility" },
  { name: "address", category: "standard" },
  { name: "adduser", category: "utility" },
  { name: "advanced_function", category: "utility" },
  { name: "advertising", category: "utility" },
  { name: "agent_home", category: "standard" },
  { name: "agent_session", category: "standard" },
  { name: "agent_session", category: "utility" },
  { name: "aggregation_policy", category: "standard" },
  { name: "alert", category: "utility" },
  { name: "all", category: "standard" },
  { name: "all", category: "utility" },
  { name: "anchor", category: "utility" },
  { name: "animal_and_nature", category: "utility" },
  { name: "announcement", category: "standard" },
  { name: "announcement", category: "utility" },
  { name: "answer", category: "utility" },
  { name: "answer_best", category: "standard" },
  { name: "answer_private", category: "standard" },
  { name: "answer_public", category: "standard" },
  { name: "answered_twice", category: "utility" },
  { name: "apex", category: "standard" },
  { name: "apex", category: "utility" },
  { name: "apex_plugin", category: "standard" },
  { name: "apex_plugin", category: "utility" },
  { name: "app", category: "standard" },
  { name: "approval", category: "standard" },
  { name: "approval", category: "utility" },
  { name: "apps", category: "standard" },
  { name: "apps", category: "utility" },
  { name: "apps_admin", category: "standard" },
  { name: "archive", category: "utility" },
  { name: "arrowdown", category: "utility" },
  { name: "arrowup", category: "utility" },
  { name: "article", category: "standard" },
  { name: "asset_action", category: "standard" },
  { name: "asset_action_source", category: "standard" },
  { name: "asset_downtime_period", category: "standard" },
  { name: "asset_object", category: "standard" },
  { name: "asset_relationship", category: "standard" },
  { name: "asset_state_period", category: "standard" },
  { name: "asset_warranty", category: "standard" },
  { name: "assigned_resource", category: "standard" },
  { name: "assignment", category: "standard" },
  { name: "assignment", category: "utility" },
  { name: "attach", category: "utility" },
  { name: "automate", category: "utility" },
  { name: "avatar", category: "standard" },
  { name: "avatar_loading", category: "standard" },
  { name: "away", category: "utility" },
  { name: "back", category: "utility" },
  { name: "ban", category: "utility" },
  { name: "block_visitor", category: "utility" },
  { name: "bold", category: "utility" },
  { name: "bookmark", category: "utility" },
  { name: "bot", category: "standard" },
  { name: "bot_training", category: "standard" },
  { name: "branch_merge", category: "standard" },
  { name: "brand", category: "standard" },
  { name: "breadcrumbs", category: "utility" },
  { name: "broadcast", category: "utility" },
  { name: "brush", category: "utility" },
  { name: "bucket", category: "utility" },
  { name: "budget", category: "standard" },
  { name: "budget_allocation", category: "standard" },
  { name: "builder", category: "utility" },
  { name: "bundle_config", category: "standard" },
  { name: "bundle_policy", category: "standard" },
  { name: "business_hours", category: "standard" },
  { name: "buyer_account", category: "standard" },
  { name: "buyer_group", category: "standard" },
  { name: "calculated_insights", category: "standard" },
  { name: "calibration", category: "standard" },
  { name: "call", category: "standard" },
  { name: "call", category: "utility" },
  { name: "call_coaching", category: "standard" },
  { name: "call_history", category: "standard" },
  { name: "campaign", category: "standard" },
  { name: "campaign", category: "utility" },
  { name: "campaign_members", category: "standard" },
  { name: "cancel_checkout", category: "standard" },
  { name: "cancel_file_request", category: "utility" },
  { name: "cancel_transfer", category: "utility" },
  { name: "canvas", category: "standard" },
  { name: "capacity_plan", category: "standard" },
  { name: "capslock", category: "utility" },
  { name: "care_request_reviewer", category: "standard" },
  { name: "carousel", category: "standard" },
  { name: "cart", category: "utility" },
  { name: "case", category: "standard" },
  { name: "case", category: "utility" },
  { name: "case_change_status", category: "standard" },
  { name: "case_comment", category: "standard" },
  { name: "case_email", category: "standard" },
  { name: "case_log_a_call", category: "standard" },
  { name: "case_milestone", category: "standard" },
  { name: "case_transcript", category: "standard" },
  { name: "case_wrap_up", category: "standard" },
  { name: "cases", category: "utility" },
  { name: "catalog", category: "standard" },
  { name: "category", category: "standard" },
  { name: "center_align_text", category: "utility" },
  { name: "change_owner", category: "utility" },
  { name: "change_record_type", category: "utility" },
  { name: "change_request", category: "standard" },
  { name: "channel_program_history", category: "standard" },
  { name: "channel_program_levels", category: "standard" },
  { name: "channel_program_members", category: "standard" },
  { name: "channel_programs", category: "standard" },
  { name: "chart", category: "standard" },
  { name: "chart", category: "utility" },
  { name: "chat", category: "utility" },
  { name: "check", category: "utility" },
  { name: "checkin", category: "utility" },
  { name: "checkout", category: "standard" },
  { name: "chevrondown", category: "utility" },
  { name: "chevronleft", category: "utility" },
  { name: "chevronright", category: "utility" },
  { name: "chevronup", category: "utility" },
  { name: "choice", category: "standard" },
  { name: "choice", category: "utility" },
  { name: "classic_interface", category: "utility" },
  { name: "clear", category: "utility" },
  { name: "client", category: "standard" },
  { name: "clock", category: "utility" },
  { name: "close", category: "utility" },
  { name: "cms", category: "standard" },
  { name: "coaching", category: "standard" },
  { name: "code_playground", category: "standard" },
  { name: "code_set", category: "standard" },
  { name: "code_set_bundle", category: "standard" },
  { name: "collapse_all", category: "utility" },
  { name: "collection", category: "standard" },
  { name: "collection_variable", category: "standard" },
  { name: "collection_variable", category: "utility" },
  { name: "color_swatch", category: "utility" },
  { name: "comments", category: "utility" },
  { name: "company", category: "utility" },
  { name: "connected_apps", category: "standard" },
  { name: "connected_apps", category: "utility" },
  { name: "constant", category: "standard" },
  { name: "constant", category: "utility" },
  { name: "contact", category: "standard" },
  { name: "contact_list", category: "standard" },
  { name: "contact_request", category: "standard" },
  { name: "contact_request", category: "utility" },
  { name: "contract", category: "standard" },
  { name: "contract", category: "utility" },
  { name: "contract_alt", category: "utility" },
  { name: "contract_line_item", category: "standard" },
  { name: "copy", category: "utility" },
  { name: "copy_to_clipboard", category: "utility" },
  { name: "coupon_codes", category: "standard" },
  { name: "crossfilter", category: "utility" },
  { name: "currency", category: "standard" },
  { name: "currency", category: "utility" },
  { name: "currency_input", category: "standard" },
  { name: "currency_input", category: "utility" },
  { name: "custom", category: "standard" },
  { name: "custom1", category: "custom" },
  { name: "custom10", category: "custom" },
  { name: "custom100", category: "custom" },
  { name: "custom101", category: "custom" },
  { name: "custom102", category: "custom" },
  { name: "custom103", category: "custom" },
  { name: "custom104", category: "custom" },
  { name: "custom105", category: "custom" },
  { name: "custom106", category: "custom" },
  { name: "custom107", category: "custom" },
  { name: "custom108", category: "custom" },
  { name: "custom109", category: "custom" },
  { name: "custom11", category: "custom" },
  { name: "custom110", category: "custom" },
  { name: "custom111", category: "custom" },
  { name: "custom112", category: "custom" },
  { name: "custom113", category: "custom" },
  { name: "custom12", category: "custom" },
  { name: "custom13", category: "custom" },
  { name: "custom14", category: "custom" },
  { name: "custom15", category: "custom" },
  { name: "custom16", category: "custom" },
  { name: "custom17", category: "custom" },
  { name: "custom18", category: "custom" },
  { name: "custom19", category: "custom" },
  { name: "custom2", category: "custom" },
  { name: "custom20", category: "custom" },
  { name: "custom21", category: "custom" },
  { name: "custom22", category: "custom" },
  { name: "custom23", category: "custom" },
  { name: "custom24", category: "custom" },
  { name: "custom25", category: "custom" },
  { name: "custom26", category: "custom" },
  { name: "custom27", category: "custom" },
  { name: "custom28", category: "custom" },
  { name: "custom29", category: "custom" },
  { name: "custom3", category: "custom" },
  { name: "custom30", category: "custom" },
  { name: "custom31", category: "custom" },
  { name: "custom32", category: "custom" },
  { name: "custom33", category: "custom" },
  { name: "custom34", category: "custom" },
  { name: "custom35", category: "custom" },
  { name: "custom36", category: "custom" },
  { name: "custom37", category: "custom" },
  { name: "custom38", category: "custom" },
  { name: "custom39", category: "custom" },
  { name: "custom4", category: "custom" },
  { name: "custom40", category: "custom" },
  { name: "custom41", category: "custom" },
  { name: "custom42", category: "custom" },
  { name: "custom43", category: "custom" },
  { name: "custom44", category: "custom" },
  { name: "custom45", category: "custom" },
  { name: "custom46", category: "custom" },
  { name: "custom47", category: "custom" },
  { name: "custom48", category: "custom" },
  { name: "custom49", category: "custom" },
  { name: "custom5", category: "custom" },
  { name: "custom50", category: "custom" },
  { name: "custom51", category: "custom" },
  { name: "custom52", category: "custom" },
  { name: "custom53", category: "custom" },
  { name: "custom54", category: "custom" },
  { name: "custom55", category: "custom" },
  { name: "custom56", category: "custom" },
  { name: "custom57", category: "custom" },
  { name: "custom58", category: "custom" },
  { name: "custom59", category: "custom" },
  { name: "custom6", category: "custom" },
  { name: "custom60", category: "custom" },
  { name: "custom61", category: "custom" },
  { name: "custom62", category: "custom" },
  { name: "custom63", category: "custom" },
  { name: "custom64", category: "custom" },
  { name: "custom65", category: "custom" },
  { name: "custom66", category: "custom" },
  { name: "custom67", category: "custom" },
  { name: "custom68", category: "custom" },
  { name: "custom69", category: "custom" },
  { name: "custom7", category: "custom" },
  { name: "custom70", category: "custom" },
  { name: "custom71", category: "custom" },
  { name: "custom72", category: "custom" },
  { name: "custom73", category: "custom" },
  { name: "custom74", category: "custom" },
  { name: "custom75", category: "custom" },
  { name: "custom76", category: "custom" },
  { name: "custom77", category: "custom" },
  { name: "custom78", category: "custom" },
  { name: "custom79", category: "custom" },
  { name: "custom8", category: "custom" },
  { name: "custom80", category: "custom" },
  { name: "custom81", category: "custom" },
  { name: "custom82", category: "custom" },
  { name: "custom83", category: "custom" },
  { name: "custom84", category: "custom" },
  { name: "custom85", category: "custom" },
  { name: "custom86", category: "custom" },
  { name: "custom87", category: "custom" },
  { name: "custom88", category: "custom" },
  { name: "custom89", category: "custom" },
  { name: "custom9", category: "custom" },
  { name: "custom90", category: "custom" },
  { name: "custom91", category: "custom" },
  { name: "custom92", category: "custom" },
  { name: "custom93", category: "custom" },
  { name: "custom94", category: "custom" },
  { name: "custom95", category: "custom" },
  { name: "custom96", category: "custom" },
  { name: "custom97", category: "custom" },
  { name: "custom98", category: "custom" },
  { name: "custom99", category: "custom" },
  { name: "custom_apps", category: "utility" },
  { name: "custom_component_task", category: "standard" },
  { name: "custom_notification", category: "standard" },
  { name: "customer_360", category: "standard" },
  { name: "customer_lifecycle_analytics", category: "standard" },
  { name: "customer_portal_users", category: "standard" },
  { name: "customers", category: "standard" },
  { name: "cut", category: "utility" },
  { name: "dash", category: "utility" },
  { name: "dashboard", category: "standard" },
  { name: "dashboard_ea", category: "standard" },
  { name: "data_integration_hub", category: "standard" },
  { name: "data_mapping", category: "standard" },
  { name: "data_model", category: "standard" },
  { name: "data_streams", category: "standard" },
  { name: "database", category: "utility" },
  { name: "datadotcom", category: "standard" },
  { name: "datadotcom", category: "utility" },
  { name: "dataset", category: "standard" },
  { name: "date_input", category: "standard" },
  { name: "date_input", category: "utility" },
  { name: "date_time", category: "standard" },
  { name: "date_time", category: "utility" },
  { name: "dayview", category: "utility" },
  { name: "decision", category: "standard" },
  { name: "default", category: "standard" },
  { name: "delegated_account", category: "standard" },
  { name: "delete", category: "utility" },
  { name: "deprecate", category: "utility" },
  { name: "description", category: "utility" },
  { name: "desktop", category: "utility" },
  { name: "desktop_console", category: "utility" },
  { name: "device", category: "standard" },
  { name: "dialing", category: "utility" },
  { name: "discounts", category: "standard" },
  { name: "dislike", category: "utility" },
  { name: "display_rich_text", category: "standard" },
  { name: "display_rich_text", category: "utility" },
  { name: "display_text", category: "standard" },
  { name: "display_text", category: "utility" },
  { name: "dock_panel", category: "utility" },
  { name: "document", category: "standard" },
  { name: "document_reference", category: "standard" },
  { name: "down", category: "utility" },
  { name: "download", category: "utility" },
  { name: "drafts", category: "standard" },
  { name: "drag", category: "utility" },
  { name: "drag_and_drop", category: "utility" },
  { name: "duration_downscale", category: "standard" },
  { name: "dynamic_record_choice", category: "standard" },
  { name: "dynamic_record_choice", category: "utility" },
  { name: "edit", category: "utility" },
  { name: "edit_form", category: "utility" },
  { name: "education", category: "standard" },
  { name: "einstein", category: "utility" },
  { name: "einstein_replies", category: "standard" },
  { name: "email", category: "standard" },
  { name: "email", category: "utility" },
  { name: "email_chatter", category: "standard" },
  { name: "email_open", category: "utility" },
  { name: "emoji", category: "utility" },
  { name: "employee", category: "standard" },
  { name: "employee_asset", category: "standard" },
  { name: "employee_contact", category: "standard" },
  { name: "employee_job", category: "standard" },
  { name: "employee_job_position", category: "standard" },
  { name: "employee_organization", category: "standard" },
  { name: "empty", category: "standard" },
  { name: "end_call", category: "utility" },
  { name: "end_chat", category: "utility" },
  { name: "end_messaging_session", category: "utility" },
  { name: "endorsement", category: "standard" },
  { name: "entitlement", category: "standard" },
  { name: "entitlement_policy", category: "standard" },
  { name: "entitlement_process", category: "standard" },
  { name: "entitlement_template", category: "standard" },
  { name: "entity", category: "standard" },
  { name: "entity_milestone", category: "standard" },
  { name: "environment_hub", category: "standard" },
  { name: "erect_window", category: "utility" },
  { name: "error", category: "utility" },
  { name: "event", category: "standard" },
  { name: "event", category: "utility" },
  { name: "events", category: "standard" },
  { name: "events", category: "utility" },
  { name: "expand", category: "utility" },
  { name: "expand_all", category: "utility" },
  { name: "expand_alt", category: "utility" },
  { name: "expense", category: "standard" },
  { name: "expense_report", category: "standard" },
  { name: "expense_report_entry", category: "standard" },
  { name: "fallback", category: "utility" },
  { name: "favorite", category: "utility" },
  { name: "feed", category: "standard" },
  { name: "feed", category: "utility" },
  { name: "feedback", category: "standard" },
  { name: "file", category: "standard" },
  { name: "file", category: "utility" },
  { name: "filter", category: "standard" },
  { name: "filter", category: "utility" },
  { name: "filterList", category: "utility" },
  { name: "filter_criteria", category: "standard" },
  { name: "filter_criteria_rule", category: "standard" },
  { name: "first_non_empty", category: "standard" },
  { name: "flow", category: "standard" },
  { name: "flow", category: "utility" },
  { name: "folder", category: "standard" },
  { name: "food_and_drink", category: "utility" },
  { name: "forecasts", category: "standard" },
  { name: "form", category: "standard" },
  { name: "formula", category: "standard" },
  { name: "formula", category: "utility" },
  { name: "forward", category: "utility" },
  { name: "forward_up", category: "utility" },
  { name: "frozen", category: "utility" },
  { name: "fulfillment_order", category: "standard" },
  { name: "fulfillment_order", category: "utility" },
  { name: "full_width_view", category: "utility" },
  { name: "generic_loading", category: "standard" },
  { name: "global_constant", category: "standard" },
  { name: "global_constant", category: "utility" },
  { name: "goals", category: "standard" },
  { name: "graph", category: "utility" },
  { name: "group_loading", category: "standard" },
  { name: "groups", category: "standard" },
  { name: "groups", category: "utility" },
  { name: "guidance_center", category: "standard" },
  { name: "help", category: "utility" },
  { name: "help_center", category: "utility" },
  { name: "hide", category: "utility" },
  { name: "hide_mobile", category: "utility" },
  { name: "hierarchy", category: "standard" },
  { name: "hierarchy", category: "utility" },
  { name: "high_velocity_sales", category: "standard" },
  { name: "holiday_operating_hours", category: "standard" },
  { name: "home", category: "standard" },
  { name: "home", category: "utility" },
  { name: "household", category: "standard" },
  { name: "identifier", category: "standard" },
  { name: "identity", category: "utility" },
  { name: "image", category: "utility" },
  { name: "immunization", category: "standard" },
  { name: "in_app_assistant", category: "utility" },
  { name: "inbox", category: "utility" },
  { name: "incident", category: "standard" },
  { name: "incoming_call", category: "utility" },
  { name: "individual", category: "standard" },
  { name: "info", category: "utility" },
  { name: "info_alt", category: "utility" },
  { name: "insert_tag_field", category: "utility" },
  { name: "insert_template", category: "utility" },
  { name: "insights", category: "standard" },
  { name: "inspector_panel", category: "utility" },
  { name: "instore_locations", category: "standard" },
  { name: "internal_share", category: "utility" },
  { name: "investment_account", category: "standard" },
  { name: "invocable_action", category: "standard" },
  { name: "iot_context", category: "standard" },
  { name: "iot_orchestrations", category: "standard" },
  { name: "italic", category: "utility" },
  { name: "javascript_button", category: "standard" },
  { name: "job_family", category: "standard" },
  { name: "job_position", category: "standard" },
  { name: "job_profile", category: "standard" },
  { name: "jump_to_bottom", category: "utility" },
  { name: "jump_to_top", category: "utility" },
  { name: "justify_text", category: "utility" },
  { name: "kanban", category: "standard" },
  { name: "kanban", category: "utility" },
  { name: "key_dates", category: "standard" },
  { name: "keyboard_dismiss", category: "utility" },
  { name: "knowledge", category: "standard" },
  { name: "knowledge_base", category: "utility" },
  { name: "layers", category: "utility" },
  { name: "layout", category: "utility" },
  { name: "lead", category: "standard" },
  { name: "lead_insights", category: "standard" },
  { name: "lead_list", category: "standard" },
  { name: "leave_conference", category: "utility" },
  { name: "left", category: "utility" },
  { name: "left_align_text", category: "utility" },
  { name: "letterhead", category: "standard" },
  { name: "level_down", category: "utility" },
  { name: "level_up", category: "utility" },
  { name: "light_bulb", category: "utility" },
  { name: "lightning_component", category: "standard" },
  { name: "lightning_inspector", category: "utility" },
  { name: "lightning_usage", category: "standard" },
  { name: "like", category: "utility" },
  { name: "link", category: "standard" },
  { name: "link", category: "utility" },
  { name: "linked", category: "utility" },
  { name: "list", category: "utility" },
  { name: "list_email", category: "standard" },
  { name: "listen", category: "utility" },
  { name: "live_chat", category: "standard" },
  { name: "live_chat_visitor", category: "standard" },
  { name: "live_message", category: "utility" },
  { name: "location", category: "standard" },
  { name: "location", category: "utility" },
  { name: "location_permit", category: "standard" },
  { name: "lock", category: "utility" },
  { name: "locker_service_api_viewer", category: "utility" },
  { name: "locker_service_console", category: "utility" },
  { name: "log_a_call", category: "standard" },
  { name: "log_a_call", category: "utility" },
  { name: "logging", category: "standard" },
  { name: "logout", category: "utility" },
  { name: "loop", category: "standard" },
  { name: "loop", category: "utility" },
  { name: "lower_flag", category: "utility" },
  { name: "macros", category: "standard" },
  { name: "macros", category: "utility" },
  { name: "magicwand", category: "utility" },
  { name: "maintenance_asset", category: "standard" },
  { name: "maintenance_plan", category: "standard" },
  { name: "maintenance_work_rule", category: "standard" },
  { name: "mark_all_as_read", category: "utility" },
  { name: "marketing_actions", category: "standard" },
  { name: "matrix", category: "utility" },
  { name: "medication", category: "standard" },
  { name: "medication_ingredient", category: "standard" },
  { name: "medication_statement", category: "standard" },
  { name: "merge", category: "standard" },
  { name: "merge", category: "utility" },
  { name: "merge_field", category: "utility" },
  { name: "messaging_conversation", category: "standard" },
  { name: "messaging_session", category: "standard" },
  { name: "messaging_user", category: "standard" },
  { name: "metrics", category: "standard" },
  { name: "metrics", category: "utility" },
  { name: "minimize_window", category: "utility" },
  { name: "missed_call", category: "utility" },
  { name: "money", category: "utility" },
  { name: "moneybag", category: "utility" },
  { name: "monthlyview", category: "utility" },
  { name: "move", category: "utility" },
  { name: "multi_picklist", category: "standard" },
  { name: "multi_picklist", category: "utility" },
  { name: "multi_select_checkbox", category: "standard" },
  { name: "multi_select_checkbox", category: "utility" },
  { name: "muted", category: "utility" },
  { name: "network_contract", category: "standard" },
  { name: "new", category: "utility" },
  { name: "new_direct_message", category: "utility" },
  { name: "new_window", category: "utility" },
  { name: "news", category: "standard" },
  { name: "news", category: "utility" },
  { name: "note", category: "standard" },
  { name: "note", category: "utility" },
  { name: "notebook", category: "utility" },
  { name: "notification", category: "utility" },
  { name: "number_input", category: "standard" },
  { name: "number_input", category: "utility" },
  { name: "observation_component", category: "standard" },
  { name: "office365", category: "utility" },
  { name: "offline", category: "utility" },
  { name: "offline_cached", category: "utility" },
  { name: "omni_channel", category: "utility" },
  { name: "omni_supervisor", category: "standard" },
  { name: "open", category: "utility" },
  { name: "open_folder", category: "utility" },
  { name: "opened_folder", category: "utility" },
  { name: "operating_hours", category: "standard" },
  { name: "opportunity", category: "standard" },
  { name: "opportunity_contact_role", category: "standard" },
  { name: "opportunity_splits", category: "standard" },
  { name: "orchestrator", category: "standard" },
  { name: "order_item", category: "standard" },
  { name: "orders", category: "standard" },
  { name: "outbound_call", category: "utility" },
  { name: "outcome", category: "standard" },
  { name: "outcome", category: "utility" },
  { name: "output", category: "standard" },
  { name: "overflow", category: "utility" },
  { name: "package", category: "utility" },
  { name: "package_org", category: "utility" },
  { name: "package_org_beta", category: "utility" },
  { name: "page", category: "utility" },
  { name: "palette", category: "utility" },
  { name: "partner_fund_allocation", category: "standard" },
  { name: "partner_fund_claim", category: "standard" },
  { name: "partner_fund_request", category: "standard" },
  { name: "partner_marketing_budget", category: "standard" },
  { name: "partners", category: "standard" },
  { name: "password", category: "standard" },
  { name: "password", category: "utility" },
  { name: "past_chat", category: "standard" },
  { name: "paste", category: "utility" },
  { name: "patient_medication_dosage", category: "standard" },
  { name: "pause", category: "utility" },
  { name: "payment_gateway", category: "standard" },
  { name: "people", category: "standard" },
  { name: "people", category: "utility" },
  { name: "performance", category: "standard" },
  { name: "person_account", category: "standard" },
  { name: "person_language", category: "standard" },
  { name: "person_name", category: "standard" },
  { name: "phone_landscape", category: "utility" },
  { name: "phone_portrait", category: "utility" },
  { name: "photo", category: "standard" },
  { name: "photo", category: "utility" },
  { name: "picklist", category: "utility" },
  { name: "picklist_choice", category: "standard" },
  { name: "picklist_choice", category: "utility" },
  { name: "picklist_type", category: "standard" },
  { name: "picklist_type", category: "utility" },
  { name: "pin", category: "utility" },
  { name: "pinned", category: "utility" },
  { name: "planogram", category: "standard" },
  { name: "play", category: "utility" },
  { name: "podcast_webinar", category: "utility" },
  { name: "poll", category: "standard" },
  { name: "pop_in", category: "utility" },
  { name: "portal", category: "standard" },
  { name: "portal_roles", category: "standard" },
  { name: "portal_roles_and_subordinates", category: "standard" },
  { name: "post", category: "standard" },
  { name: "power", category: "utility" },
  { name: "practitioner_role", category: "standard" },
  { name: "preview", category: "utility" },
  { name: "price_book_entries", category: "standard" },
  { name: "price_books", category: "standard" },
  { name: "pricebook", category: "standard" },
  { name: "pricing_workspace", category: "standard" },
  { name: "print", category: "utility" },
  { name: "priority", category: "utility" },
  { name: "privately_shared", category: "utility" },
  { name: "problem", category: "standard" },
  { name: "procedure", category: "standard" },
  { name: "procedure_detail", category: "standard" },
  { name: "process", category: "standard" },
  { name: "process", category: "utility" },
  { name: "process_exception", category: "standard" },
  { name: "product", category: "standard" },
  { name: "product_consumed", category: "standard" },
  { name: "product_consumed_state", category: "standard" },
  { name: "product_item", category: "standard" },
  { name: "product_item_transaction", category: "standard" },
  { name: "product_quantity_rules", category: "standard" },
  { name: "product_request", category: "standard" },
  { name: "product_request_line_item", category: "standard" },
  { name: "product_required", category: "standard" },
  { name: "product_service_campaign", category: "standard" },
  { name: "product_service_campaign_item", category: "standard" },
  { name: "product_transfer", category: "standard" },
  { name: "product_transfer_state", category: "standard" },
  { name: "product_warranty_term", category: "standard" },
  { name: "product_workspace", category: "standard" },
  { name: "products", category: "standard" },
  { name: "promotion_segments", category: "standard" },
  { name: "promotions", category: "standard" },
  { name: "promotions_workspace", category: "standard" },
  { name: "prompt", category: "utility" },
  { name: "prompt_edit", category: "utility" },
  { name: "propagation_policy", category: "standard" },
  { name: "proposition", category: "standard" },
  { name: "push", category: "utility" },
  { name: "puzzle", category: "utility" },
  { name: "qualifications", category: "standard" },
  { name: "question", category: "utility" },
  { name: "question_best", category: "standard" },
  { name: "question_feed", category: "standard" },
  { name: "question_mark", category: "utility" },
  { name: "questions_and_answers", category: "utility" },
  { name: "queue", category: "standard" },
  { name: "quick_text", category: "standard" },
  { name: "quick_text", category: "utility" },
  { name: "quip", category: "standard" },
  { name: "quip_sheet", category: "standard" },
  { name: "quotation_marks", category: "utility" },
  { name: "quote", category: "utility" },
  { name: "quotes", category: "standard" },
  { name: "radio_button", category: "standard" },
  { name: "radio_button", category: "utility" },
  { name: "rating", category: "utility" },
  { name: "read_receipts", category: "standard" },
  { name: "reassign", category: "utility" },
  { name: "recent", category: "standard" },
  { name: "recipe", category: "standard" },
  { name: "record", category: "standard" },
  { name: "record", category: "utility" },
  { name: "record_create", category: "standard" },
  { name: "record_create", category: "utility" },
  { name: "record_delete", category: "standard" },
  { name: "record_delete", category: "utility" },
  { name: "record_lookup", category: "standard" },
  { name: "record_lookup", category: "utility" },
  { name: "record_signature_task", category: "standard" },
  { name: "record_update", category: "standard" },
  { name: "record_update", category: "utility" },
  { name: "recurring_exception", category: "utility" },
  { name: "recycle_bin", category: "standard" },
  { name: "redo", category: "utility" },
  { name: "refresh", category: "utility" },
  { name: "relate", category: "utility" },
  { name: "related_list", category: "standard" },
  { name: "relationship", category: "standard" },
  { name: "reminder", category: "utility" },
  { name: "remove_formatting", category: "utility" },
  { name: "remove_link", category: "utility" },
  { name: "replace", category: "utility" },
  { name: "reply", category: "utility" },
  { name: "reply_all", category: "utility" },
  { name: "reply_text", category: "standard" },
  { name: "report", category: "standard" },
  { name: "report_issue", category: "utility" },
  { name: "reset_password", category: "utility" },
  { name: "resource_absence", category: "standard" },
  { name: "resource_absence", category: "utility" },
  { name: "resource_capacity", category: "standard" },
  { name: "resource_capacity", category: "utility" },
  { name: "resource_preference", category: "standard" },
  { name: "resource_skill", category: "standard" },
  { name: "resource_territory", category: "utility" },
  { name: "restriction_policy", category: "standard" },
  { name: "return_order", category: "standard" },
  { name: "return_order_line_item", category: "standard" },
  { name: "retweet", category: "utility" },
  { name: "reward", category: "standard" },
  { name: "ribbon", category: "utility" },
  { name: "richtextbulletedlist", category: "utility" },
  { name: "richtextindent", category: "utility" },
  { name: "richtextnumberedlist", category: "utility" },
  { name: "richtextoutdent", category: "utility" },
  { name: "right", category: "utility" },
  { name: "right_align_text", category: "utility" },
  { name: "rotate", category: "utility" },
  { name: "routing_offline", category: "utility" },
  { name: "rows", category: "utility" },
  { name: "rtc_presence", category: "standard" },
  { name: "rules", category: "utility" },
  { name: "sales_cadence", category: "standard" },
  { name: "sales_cadence_target", category: "standard" },
  { name: "sales_channel", category: "standard" },
  { name: "sales_path", category: "standard" },
  { name: "sales_value", category: "standard" },
  { name: "salesforce1", category: "utility" },
  { name: "salesforce_cms", category: "standard" },
  { name: "save", category: "utility" },
  { name: "scan_card", category: "standard" },
  { name: "schedule_objective", category: "standard" },
  { name: "scheduling_constraint", category: "standard" },
  { name: "scheduling_policy", category: "standard" },
  { name: "screen", category: "standard" },
  { name: "screen", category: "utility" },
  { name: "search", category: "standard" },
  { name: "search", category: "utility" },
  { name: "section", category: "standard" },
  { name: "segments", category: "standard" },
  { name: "selling_model", category: "standard" },
  { name: "send", category: "utility" },
  { name: "sentiment_negative", category: "utility" },
  { name: "sentiment_neutral", category: "utility" },
  { name: "serialized_product", category: "standard" },
  { name: "serialized_product_transaction", category: "standard" },
  { name: "service_appointment", category: "standard" },
  { name: "service_appointment_capacity_usage", category: "standard" },
  { name: "service_contract", category: "standard" },
  { name: "service_crew", category: "standard" },
  { name: "service_crew_member", category: "standard" },
  { name: "service_report", category: "standard" },
  { name: "service_request", category: "standard" },
  { name: "service_request_detail", category: "standard" },
  { name: "service_resource", category: "standard" },
  { name: "service_territory", category: "standard" },
  { name: "service_territory_location", category: "standard" },
  { name: "service_territory_member", category: "standard" },
  { name: "service_territory_policy", category: "standard" },
  { name: "settings", category: "standard" },
  { name: "settings", category: "utility" },
  { name: "setup", category: "utility" },
  { name: "setup_assistant_guide", category: "utility" },
  { name: "setup_modal", category: "utility" },
  { name: "share", category: "utility" },
  { name: "share_file", category: "utility" },
  { name: "share_mobile", category: "utility" },
  { name: "share_post", category: "utility" },
  { name: "shield", category: "utility" },
  { name: "shift", category: "standard" },
  { name: "shift_pattern", category: "standard" },
  { name: "shift_pattern_entry", category: "standard" },
  { name: "shift_preference", category: "standard" },
  { name: "shift_scheduling_operation", category: "standard" },
  { name: "shift_template", category: "standard" },
  { name: "shift_type", category: "standard" },
  { name: "shipment", category: "standard" },
  { name: "shopping_bag", category: "utility" },
  { name: "shortcuts", category: "utility" },
  { name: "side_list", category: "utility" },
  { name: "signpost", category: "utility" },
  { name: "skill", category: "standard" },
  { name: "skill_entity", category: "standard" },
  { name: "skill_requirement", category: "standard" },
  { name: "skip", category: "utility" },
  { name: "slider", category: "standard" },
  { name: "smiley_and_people", category: "utility" },
  { name: "sms", category: "standard" },
  { name: "sms", category: "utility" },
  { name: "snippet", category: "standard" },
  { name: "snippet", category: "utility" },
  { name: "snippets", category: "standard" },
  { name: "sobject", category: "standard" },
  { name: "sobject", category: "utility" },
  { name: "sobject_collection", category: "standard" },
  { name: "sobject_collection", category: "utility" },
  { name: "social", category: "standard" },
  { name: "socialshare", category: "utility" },
  { name: "solution", category: "standard" },
  { name: "sort", category: "standard" },
  { name: "sort", category: "utility" },
  { name: "sort_policy", category: "standard" },
  { name: "sossession", category: "standard" },
  { name: "spinner", category: "utility" },
  { name: "stage", category: "standard" },
  { name: "stage", category: "utility" },
  { name: "stage_collection", category: "standard" },
  { name: "stage_collection", category: "utility" },
  { name: "standard_objects", category: "utility" },
  { name: "steps", category: "standard" },
  { name: "steps", category: "utility" },
  { name: "stop", category: "utility" },
  { name: "store", category: "standard" },
  { name: "store_group", category: "standard" },
  { name: "story", category: "standard" },
  { name: "strategy", category: "standard" },
  { name: "strategy", category: "utility" },
  { name: "strikethrough", category: "utility" },
  { name: "success", category: "utility" },
  { name: "summary", category: "utility" },
  { name: "summarydetail", category: "utility" },
  { name: "survey", category: "standard" },
  { name: "survey", category: "utility" },
  { name: "swarm_request", category: "standard" },
  { name: "swarm_session", category: "standard" },
  { name: "switch", category: "utility" },
  { name: "symbols", category: "utility" },
  { name: "sync", category: "utility" },
  { name: "system_and_global_variable", category: "standard" },
  { name: "system_and_global_variable", category: "utility" },
  { name: "table", category: "utility" },
  { name: "tablet_landscape", category: "utility" },
  { name: "tablet_portrait", category: "utility" },
  { name: "tabset", category: "utility" },
  { name: "task", category: "standard" },
  { name: "task", category: "utility" },
  { name: "task2", category: "standard" },
  { name: "team_member", category: "standard" },
  { name: "template", category: "standard" },
  { name: "text", category: "standard" },
  { name: "text", category: "utility" },
  { name: "text_background_color", category: "utility" },
  { name: "text_color", category: "utility" },
  { name: "text_template", category: "standard" },
  { name: "text_template", category: "utility" },
  { name: "textarea", category: "standard" },
  { name: "textarea", category: "utility" },
  { name: "textbox", category: "standard" },
  { name: "textbox", category: "utility" },
  { name: "thanks", category: "standard" },
  { name: "thanks_loading", category: "standard" },
  { name: "threedots", category: "utility" },
  { name: "threedots_vertical", category: "utility" },
  { name: "thunder", category: "utility" },
  { name: "tile_card_list", category: "utility" },
  { name: "timesheet", category: "standard" },
  { name: "timesheet_entry", category: "standard" },
  { name: "timeslot", category: "standard" },
  { name: "today", category: "standard" },
  { name: "toggle", category: "standard" },
  { name: "toggle_panel_bottom", category: "utility" },
  { name: "toggle_panel_left", category: "utility" },
  { name: "toggle_panel_right", category: "utility" },
  { name: "toggle_panel_top", category: "utility" },
  { name: "topic", category: "standard" },
  { name: "topic", category: "utility" },
  { name: "topic2", category: "standard" },
  { name: "topic2", category: "utility" },
  { name: "touch_action", category: "utility" },
  { name: "tracker", category: "utility" },
  { name: "trail", category: "utility" },
  { name: "trailhead", category: "standard" },
  { name: "trailhead", category: "utility" },
  { name: "trailhead_alt", category: "standard" },
  { name: "travel_and_places", category: "utility" },
  { name: "travel_mode", category: "standard" },
  { name: "trending", category: "utility" },
  { name: "turn_off_notifications", category: "utility" },
  { name: "type", category: "utility" },
  { name: "type_tool", category: "utility" },
  { name: "undelete", category: "utility" },
  { name: "undeprecate", category: "utility" },
  { name: "underline", category: "utility" },
  { name: "undo", category: "utility" },
  { name: "unlinked", category: "utility" },
  { name: "unlock", category: "utility" },
  { name: "unmatched", category: "standard" },
  { name: "unmuted", category: "utility" },
  { name: "up", category: "utility" },
  { name: "upload", category: "utility" },
  { name: "user", category: "standard" },
  { name: "user", category: "utility" },
  { name: "user_role", category: "standard" },
  { name: "user_role", category: "utility" },
  { name: "variable", category: "standard" },
  { name: "variable", category: "utility" },
  { name: "variation_attribute_setup", category: "standard" },
  { name: "variation_products", category: "standard" },
  { name: "video", category: "standard" },
  { name: "video", category: "utility" },
  { name: "visit_templates", category: "standard" },
  { name: "visits", category: "standard" },
  { name: "visualforce_page", category: "standard" },
  { name: "voice_call", category: "standard" },
  { name: "voicemail_drop", category: "utility" },
  { name: "volume_high", category: "utility" },
  { name: "volume_low", category: "utility" },
  { name: "volume_off", category: "utility" },
  { name: "waits", category: "standard" },
  { name: "waits", category: "utility" },
  { name: "warning", category: "utility" },
  { name: "warranty_term", category: "standard" },
  { name: "webcart", category: "standard" },
  { name: "weeklyview", category: "utility" },
  { name: "wifi", category: "utility" },
  { name: "work_capacity_limit", category: "standard" },
  { name: "work_capacity_usage", category: "standard" },
  { name: "work_contract", category: "standard" },
  { name: "work_forecast", category: "standard" },
  { name: "work_order", category: "standard" },
  { name: "work_order_item", category: "standard" },
  { name: "work_order_type", category: "utility" },
  { name: "work_plan", category: "standard" },
  { name: "work_plan_rule", category: "standard" },
  { name: "work_plan_template", category: "standard" },
  { name: "work_plan_template_entry", category: "standard" },
  { name: "work_queue", category: "standard" },
  { name: "work_step", category: "standard" },
  { name: "work_step_template", category: "standard" },
  { name: "work_type", category: "standard" },
  { name: "work_type_group", category: "standard" },
  { name: "world", category: "utility" },
  { name: "yubi_key", category: "utility" },
  { name: "zoomin", category: "utility" },
  { name: "zoomout", category: "utility" }
];

export { ICONS };
